import { USPS } from "@/config/usps";

const USPSection = () => (
  <section className="py-16 sm:py-24 bg-[#E3EAE4]/60" id="why-youll-love-us" data-testid="usp-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-10 sm:mb-14 text-center mx-auto max-w-3xl">
        <p className="text-xs font-mono uppercase tracking-[0.2em] font-semibold text-[#C28519] mb-3" data-testid="usp-overline">
          15+ Years of Travel Expertise
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#0F2F24] text-balance">
          Why You'll Love Us
        </h2>
        <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
          Fifteen reasons travellers choose Book Kashmir — and come back with stories.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {USPS.map(({ icon: Icon, title, text }, i) => (
          <div key={title} className="group rounded-xl bg-white p-6 ring-1 ring-[#0F2F24]/8 shadow-sm transition-shadow hover:shadow-md" data-testid={`usp-card-${i + 1}`}>
            <div className="flex items-start justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#E3EAE4] transition-colors group-hover:bg-[#0F2F24]">
                <Icon className="h-5 w-5 text-[#0F2F24] transition-colors group-hover:text-[#D99B26]" />
              </span>
              <span className="font-mono text-sm font-semibold text-[#D99B26]">{String(i + 1).padStart(2, "0")}</span>
            </div>
            <h3 className="mt-4 font-serif text-lg font-semibold text-[#0F2F24] leading-snug">{title}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{text}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default USPSection;
